/**
 * defa.collections.notificationHolders
 * A Collection of NotificationHolder
 * @version 1.0.0
 */
import NotificationHolder from 'scripts/defa/control/notification-holders/model-notification-holder';

const NotificationHolders = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model : NotificationHolder,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

} );

export default NotificationHolders